import { useNavigate } from 'react-router-dom';
import Container from '/@/components/new-login/container';
import useIsMobile from '/@/utils/hooks/is-mobile';
import { reverse } from '/@/utils/router';
import PasswordResetRequest from './request';

/**
 * Route-level wrapper for `PasswordResetRequest` (`/users/reset-password/`).
 *
 * The login page renders the very same form inline: inside `Container` on desktop, so it
 * sits next to the brand artwork, and full-screen on mobile. Reached as its own URL the
 * form has to reproduce that itself, or it renders as a bare column on an empty page.
 *
 * `onClick` backs both the header arrow and the "Volver" button on the sent screen; the
 * login page passes its own, and without one here both are dead.
 */
const PasswordResetRequestScreen = () => {
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    const form = <PasswordResetRequest onClick={() => navigate(reverse('Login'))} />;

    if (isMobile) return form;
    return (
        <Container showLanguage hideButtons>
            {form}
        </Container>
    );
};

export default PasswordResetRequestScreen;
